import { FileCheck, FileSearch, FileSpreadsheet, Files } from 'lucide-react';
import type { FeatureContent } from './types';

export const analisiDocumentale: FeatureContent = {
  slug: 'analisi-documentale',
  navLabel: 'Analisi documentale',
  menuDescription:
    'Carica PDF, Word, Excel, TXT, XML, XBRL e immagini e analizzali insieme al quesito e alle fonti rilevanti.',
  cardDescription:
    'Carica PDF, Word, Excel, TXT, XML, XBRL e immagini e analizzali insieme al tuo quesito e alle fonti rilevanti.',
  meta: {
    title: 'Analisi documentale con AI',
    description:
      'Carica bilanci, accertamenti, contratti, visure, cedolini e dichiarazioni: Trovanorma li analizza nel contesto del tuo quesito e li mette in relazione con le fonti rilevanti.',
  },
  hero: {
    title: 'Analisi documentale',
    subtitle:
      'Bilanci, accertamenti, contratti, visure, cedolini, dichiarazioni e altri allegati: Trovanorma li analizza nel contesto del tuo quesito e li mette in relazione con le fonti rilevanti, per aiutarti a individuare dati, criticità e passaggi da approfondire.',
  },
  statement: 'Il documento è solo l’inizio dell’analisi',
  statementText:
    'Trovanorma mette insieme ciò che contiene, il contesto del caso e le fonti di riferimento per portare in evidenza gli elementi che contano.',
  blocks: [
    {
      icon: FileSearch,
      kicker: 'Atti e provvedimenti',
      title: 'Accertamenti, cartelle e perizie',
      description:
        'Analizza atti e documenti ricevuti per ricostruirne contenuto e riferimenti e individuare i profili che meritano una verifica o un approfondimento.',
    },
    {
      icon: FileSpreadsheet,
      kicker: 'Bilanci e documenti fiscali',
      title: 'Bilanci, dichiarazioni e prospetti',
      description:
        'Carica bilanci, fogli Excel, modelli dichiarativi, cedolini e prospetti e interroga direttamente dati e contenuti nel contesto della pratica.',
    },
    {
      icon: FileCheck,
      kicker: 'Contratti e documenti societari',
      title: 'Contratti, visure, verbali e delibere',
      description:
        'Analizza clausole, dati societari, cariche, partecipazioni, obblighi e altri elementi rilevanti direttamente dai documenti che hai ricevuto.',
    },
    {
      icon: Files,
      kicker: 'Allegati e formati',
      title: 'Metti insieme tutti i documenti del caso',
      description:
        'Carica PDF, Word, Excel, TXT, XML, XBRL e immagini e analizzali insieme, anche quando le informazioni che ti servono sono distribuite tra più allegati.',
    },
  ],
  steps: [
    {
      step: 1,
      title: 'Carica i documenti',
      description: 'Aggiungi uno o più allegati: PDF, Word, Excel, TXT, XML, XBRL o immagini.',
    },
    {
      step: 2,
      title: 'Dai il contesto',
      description:
        'Spiega che cosa vuoi verificare, individuare o approfondire e quali elementi del caso sono rilevanti.',
    },
    {
      step: 3,
      title: 'Analizza e approfondisci',
      description:
        'Trovanorma lavora sui documenti insieme al tuo quesito e alle fonti pertinenti, così puoi approfondire direttamente i punti che emergono.',
    },
  ],
  relatedSolutions: ['commercialisti', 'avvocati', 'aziende'],
  closing: {
    title: 'Provalo sul prossimo documento che devi analizzare',
    text: 'Carica un documento reale e verifica come Trovanorma può aiutarti a individuare dati, riferimenti e passaggi rilevanti nel contesto del tuo lavoro.',
  },
};
